module.exports = __webpack_public_path__ + "img/Rennes.49403f09.png";